import * as React from "react";

export interface VStackProps extends React.HTMLAttributes<HTMLDivElement> {
  gap?: React.CSSProperties["gap"];
  align?: React.CSSProperties["alignItems"];
  justify?: React.CSSProperties["justifyContent"];
}

const VStack = ({
  gap = "var(--space-xs)",
  align,
  justify,
  style,
  ...props
}: VStackProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap,
        alignItems: align,
        justifyContent: justify,
        ...style,
      }}
      {...props}
    />
  );
};

export { VStack };
